import fetch from "../auth/GenericFetchInterceptorV5";

// Service per la gestione dei DDT
const DdtService = {

    async list(companyId) {
        const res = await fetch({
            url: `/api/ddts?populate[0]=lots&populate[1]=supplier&filters[company][documentId]=${companyId}`,
            method: 'GET',
        })
        return {data: res.data};
    },
    async create(data, companyId) {
        return fetch({
            url: `/api/ddts/create/supplier-ddt?companyId=${companyId}`,
            method: 'POST',
            data: data
        })
    },
    async createMds(data, companyId) {
        return fetch({
            url: `/api/ddts/create/mds-ddt?companyId=${companyId}`,
            method: 'POST',
            data: data
        })
    },
    // Nuovo: dettaglio DDT con populate completo (lots, product, warehouse_articles.storage, supplier)
    async getByDocumentIdAll(documentId) {
        return fetch({
            url: `/api/ddts/${documentId}?populate[0]=lots.devices.patient&populate[1]=lots.product&populate[2]=lots.warehouse_articles.storage&populate[3]=supplier&populate[4]=company`,
            method: 'GET'
        })
    },
    // Nuovo: azione di riparazione su lotto associato a DDT
    async repairLot({ ddtDocumentId, lotDocumentId, newSerial, reason }) {
        return fetch({
            url: `/api/ddts/repair/repair-lots`,
            method: 'POST',
            data: { ddtDocumentId, lotDocumentId, newSerial, reason }
        })
    },
    // Nuovo: riparazione multipla di lotti in una singola chiamata
    async repairLotsBulk({ ddtDocumentId, ddtId, ddtReferenceCode, repairs }) {
        return fetch({
            url: `/api/ddts/repair/repair-lots`,
            method: 'POST',
            data: { ddtDocumentId, ddtId, ddtReferenceCode, repairs }
        })
    },
    // Aggiorna DDT (es. per salvare note)
    async update(documentId, data) {
        return fetch({
            url: `/api/ddts/${documentId}`,
            method: 'PUT',
            data: data
        })
    },
};

export default DdtService;
